import React from 'react';
import { useFormikContext } from 'formik';
import { FormControl, Typography } from '@mui/material';
import { YesNoSelector } from '@fnol/library/src/components';
import { legalPersonType, personType, translations } from '../../lib/consts';
import Individual from '../Individual';
import LegalLeasingEntity from '../LegalLeasingEntity';
import LegalIndividualSelector from '../LegalIndividualSelector';
import { IndividualCleanup } from '../Individual/Individual';
import { LegalLeasingCleanup } from '../LegalLeasingEntity/LegalLeasingEntity';

const VehicleOwner = () => {
    const { values, setFieldValue } = useFormikContext<any>();

    let LegalEntityUpperCase = '';
    if (values.submitterType === legalPersonType.legal) {
        LegalEntityUpperCase = values.submitterLegalNameForDisplay.toUpperCase();
    }

    const handleChangeIsSubmitterOwnerOfVehicle = () => {
        setFieldValue('ownerType', legalPersonType.initialValue);
        IndividualCleanup(personType.owner, setFieldValue);
        LegalLeasingCleanup(personType.owner, setFieldValue);
    };

    return (
        <>
            <Typography style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '16px' }} variant="subtitle1">
                {translations.vehicleOwner.VEHICLE_OWNER}
            </Typography>
            {values.submitterType === legalPersonType.individual && (
                <>
                    <Typography variant="subtitle1">{translations.vehicleOwner.DO_YOU_OWN_VEHICLE}</Typography>
                </>
            )}
            {values.submitterType === legalPersonType.legal && (
                <>
                    <Typography variant="subtitle1">{`${translations.vehicleOwner.APLICANT_OWNER_OF_VEHICLE}  ${LegalEntityUpperCase} ${translations.vehicleOwner.APLICANT2}`}</Typography>
                </>
            )}
            <FormControl>
                <YesNoSelector name="isSubmitterOwnerOfVehicle" onChange={handleChangeIsSubmitterOwnerOfVehicle} />
            </FormControl>
            {values.isSubmitterOwnerOfVehicle === 'false' ? (
                <>
                    <Typography variant="subtitle1">{translations.vehicleOwner.OWNER_IS}</Typography>
                    <FormControl>
                        <LegalIndividualSelector selectorType={personType.owner} />
                    </FormControl>

                    {values.ownerType === legalPersonType.individual && (
                        <Individual individualType={personType.owner} />
                    )}
                    {values.ownerType === legalPersonType.legal && (
                        <LegalLeasingEntity legalEntityType={personType.owner} />
                    )}
                </>
            ) : null}
        </>
    );
};

export default VehicleOwner;
